import { memo } from 'react';

import { type AssetCustomFieldValue } from '@air/api/types';

import { CustomFieldListWithOverflow } from '~/components/CustomFields/CustomFieldListWithOverflow';

export type AssetModalContentHeaderCustomFieldsProps = {
  customFields: AssetCustomFieldValue[] | undefined;
};

export const AssetModalContentHeaderCustomFields = memo(
  ({ customFields }: AssetModalContentHeaderCustomFieldsProps) => {
    if (!customFields?.length) {
      return null;
    }

    return (
      <div className="flex items-center" data-testid="ASSET_MODAL_CONTENT_CUSTOM_FIELDS">
        <CustomFieldListWithOverflow
          customFields={customFields}
          allowedWidth={350}
          hasDarkBackground
          shouldShowTooltip
        />
      </div>
    );
  },
);

AssetModalContentHeaderCustomFields.displayName = 'AssetModalContentHeaderCustomFields';
